/* Text box using material UI */

import { TextField } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import _ from 'lodash';
import { useField } from "formik";
import { at } from 'lodash';
import useMUIStyleHelper from "../UseMUIStyleHelper";



function CsplTextBoxField(props) {
  const { errorText, ...rest } = props;
  const [field, meta] = useField(props);
  const { t } = useTranslation("common");
  const { name } = field
  const [fieldValue, setFieldValue] =useState();   
  const { mandatoryClasses, nonMandatoryClasses } = useMUIStyleHelper();

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
  }


  useEffect(() => {
  
    if(field.value){
      if (getUpperCaseValue(field.value) !== getUpperCaseValue(fieldValue)) {
      setFieldValue(getUpperCaseValue(field.value));
      }
    }else{
      setFieldValue("");
    }
  
  // eslint-disable-next-line
}, [field.value]);

  const onChange = (evt) => {
    evt.preventDefault();
    setFieldValue(getUpperCaseValue(evt.target.value));
    if(props.onValueChange && typeof(props.onValueChange)==="function"){
      props.onValueChange(getUpperCaseValue(evt.target.value));
    }
  };

  const onBlur = (evt) => {
    const val = evt.target.value || "";
    window.setTimeout(() => {
       field.onChange({
        target: {
          name: props.name,
          value: getUpperCaseValue(val),
        },
      }); 
      /* field.onChange(evt); */
      field.onBlur(evt);
    }, 0);
    if(props.onBlur && typeof(props.onBlur)==="function"){
      props.onBlur(getUpperCaseValue(evt.target.value));
    }
  };

function getUpperCaseValue(value){
  if(value){
    return value.toUpperCase()
  }
  return value;
}

  return ( 
    <>
      {props.required ?  <TextField
      type="text"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      value={fieldValue}
      onBlur={onBlur}
      onChange ={onChange}
      size="small"
      variant="outlined"
      fullWidth
      label={t(props.label)}
     //inputProps={{ style: { textTransform: "uppercase" } }} 
      InputLabelProps={{ shrink: true }} 
      className={mandatoryClasses.root}
    /> :
     <TextField
      type="text"
      error={meta.touched && meta.error && true}
      helperText={_renderHelperText()}
      {...field}
      {...rest}
      value={fieldValue}
      onBlur={onBlur}
      onChange ={onChange}
      size="small"
      variant="outlined"
      fullWidth
      label={t(props.label)}
      // inputProps={{ style: { textTransform: "uppercase" } }} 
      InputLabelProps={{ shrink: true }} 
      className={nonMandatoryClasses.root}
    />}
    </> 
  );
}
export default CsplTextBoxField;
